module.exports = __webpack_public_path__ + "img/arrow-left.0e838c39.svg";